(function () {
  if (customElements.get('ge-media-tabs')) return;

  class GeMediaTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ge-media-tab]'));
      this.photos = Array.from(this.querySelectorAll('[data-ge-media-photo]'));
      this.mobileSlides = Array.from(this.querySelectorAll('[data-ge-media-mobile-slide]'));
      this.mobileTrack = this.querySelector('[data-ge-media-mobile-track]');
      if (this.tabs.length === 0) return;

      this.durationMs = (parseInt(this.dataset.duration, 10) || 8) * 1000;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.loopEnabled = this.dataset.loop !== 'false';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.activeIndex = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.onTabClick = this.onTabClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onProgressEnd = this.onProgressEnd.bind(this);
      this.pause = this.pause.bind(this);
      this.resume = this.resume.bind(this);
      this.onMobileScroll = this.onMobileScroll.bind(this);

      this.tabs.forEach((tab, index) => {
        var trigger = tab.querySelector('[data-ge-media-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', () => this.activate(index));
        trigger.addEventListener('keydown', this.onKeydown);
      });

      if (this.pauseOnHover && this.autoplayEnabled && !this.reduceMotion) {
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resume();
        });
      }

      if (this.mobileTrack) {
        this.mobileTrack.addEventListener('scroll', this.onMobileScroll, { passive: true });
      }

      this.activate(this.activeIndex);
    }

    disconnectedCallback() {
      this.pause();
    }

    onMobileScroll() {
      if (!this.mobileTrack || !this.mobileSlides.length) return;
      if (this._scrollTicking) return;
      this._scrollTicking = true;
      window.requestAnimationFrame(() => {
        this._scrollTicking = false;
        var track = this.mobileTrack;
        var slide = this.mobileSlides[0];
        if (!slide) return;
        var slideWidth = slide.offsetWidth + 12;
        var index = Math.round(track.scrollLeft / slideWidth);
        index = Math.max(0, Math.min(index, this.mobileSlides.length - 1));
        if (index !== this.activeIndex) {
          this.activate(index, { scrollMobile: false });
        }
      });
    }

    onTabClick(event) {
      var trigger = event.currentTarget;
      var tab = trigger.closest('[data-ge-media-tab]');
      if (!tab) return;
      var index = this.tabs.indexOf(tab);
      if (index >= 0) this.activate(index);
    }

    onKeydown(event) {
      var trigger = event.currentTarget;
      var tab = trigger.closest('[data-ge-media-tab]');
      if (!tab) return;
      var index = this.tabs.indexOf(tab);
      if (index < 0) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.activate((index + 1) % this.tabs.length);
        this.focusTrigger((index + 1) % this.tabs.length);
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        var prev = (index - 1 + this.tabs.length) % this.tabs.length;
        this.activate(prev);
        this.focusTrigger(prev);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.activate(0);
        this.focusTrigger(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        var last = this.tabs.length - 1;
        this.activate(last);
        this.focusTrigger(last);
      }
    }

    focusTrigger(index) {
      var tab = this.tabs[index];
      var trigger = tab && tab.querySelector('[data-ge-media-trigger]');
      if (trigger) trigger.focus();
    }

    activate(index, options) {
      options = options || {};
      if (index < 0 || index >= this.tabs.length) return;
      this.activeIndex = index;

      this.tabs.forEach((tab, i) => {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        var trigger = tab.querySelector('[data-ge-media-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
        var panel = tab.querySelector('[data-ge-media-panel]');
        if (panel) panel.hidden = !on;
      });

      this.photos.forEach((photo) => {
        photo.classList.toggle('is-active', photo.dataset.index === String(index));
      });

      this.mobileSlides.forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.index === String(index));
      });

      if (options.scrollMobile !== false && this.mobileTrack && this.mobileSlides[index]) {
        var slide = this.mobileSlides[index];
        this.mobileTrack.scrollTo({
          left: slide.offsetLeft - this.mobileTrack.offsetLeft,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }

      this.resetProgress();
      if (this.autoplayEnabled && !this.reduceMotion && !this.paused) {
        this.startProgress();
      }
    }

    resetProgress() {
      this.querySelectorAll('[data-ge-media-progress-fill]').forEach((fill) => {
        fill.classList.remove('is-animating');
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      });
      if (this.progressTimer) {
        window.clearTimeout(this.progressTimer);
        this.progressTimer = null;
      }
    }

    startProgress() {
      var activeTab = this.tabs[this.activeIndex];
      var activeSlide = this.mobileSlides[this.activeIndex];
      var fill =
        (activeTab && activeTab.querySelector('[data-ge-media-progress-fill]')) ||
        (activeSlide && activeSlide.querySelector('[data-ge-media-progress-fill]'));
      if (!fill) return;

      fill.classList.add('is-animating');
      fill.addEventListener('animationend', this.onProgressEnd, { once: true });
      this.progressTimer = window.setTimeout(this.onProgressEnd, this.durationMs + 50);
    }

    onProgressEnd() {
      if (!this.autoplayEnabled || this.reduceMotion || this.paused) return;
      if (this._advancing) return;
      this._advancing = true;
      var next = this.activeIndex + 1;
      if (next >= this.tabs.length) {
        next = this.loopEnabled ? 0 : this.activeIndex;
      }
      if (next !== this.activeIndex) this.activate(next);
      this._advancing = false;
    }

    pause() {
      this.paused = true;
      this.resetProgress();
    }

    resume() {
      if (!this.autoplayEnabled || this.reduceMotion) return;
      this.paused = false;
      this.startProgress();
    }
  }

  customElements.define('ge-media-tabs', GeMediaTabs);
})();
